import { render, staticRenderFns } from "./LevelCompareStandalone.vue?vue&type=template&id=71a3df34&scoped=true"
import script from "./LevelCompareStandalone.vue?vue&type=script&lang=js"
export * from "./LevelCompareStandalone.vue?vue&type=script&lang=js"
import style0 from "./LevelCompareStandalone.vue?vue&type=style&index=0&id=71a3df34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3df34",
  null
  
)

export default component.exports